import React from "react";
import ReactDOM from "react-dom";
import {createBrowserHistory} from "history";
import {Route, Router, Switch} from "react-router-dom";
import Splashscreen from "components/Splashscreen";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

import indexRoutes from "routes/index.jsx";

import "assets/scss/material-dashboard-pro-react.scss";

import "assets/css/others.css";

import connection from "./connection";
import general from "./general";
import CustomInput from "./components/CustomInput/CustomInput";
import SweetAlert from "./components/SweetAlertWrapper";

const hist = createBrowserHistory();

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      user: null,
      modal: null,
      confirm: null
    };

    this.hist = hist;
    window.App = this;
    general.notificationManager = NotificationManager;

    this.setUser = this.setUser.bind(this);
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.setState({
      user: {},
      ready: true
    });
    window.App.hist.push("/login");
  }

  render() {
    let app;
    if (!this.state.ready) {
      app = (<Splashscreen/>);
    } else {
      app = this.props.children;
    }
    return <React.Fragment>
      {app}
      {this.state.modal}
      {this.state.confirm}
    </React.Fragment>;
  }

  setUser(user) {
    this.setState({
      user: user
    });
  }

  getLoginState = (callback) => {
    connection.get("utilizador/state", null, (data) => {
      if (data.success) {
        this.setState({
          ready: true,
          user: data
        });
      } else {
        window.App.hist.push("/login");
      }
      callback(data);
    })
  }

  componentDidMount() {
    if (window.location.pathname === "/login") {
      if (!this.state.ready) {
        this.setState({
          ready: true
        });
      }
    } else {
      this.getLoginState();
    }
  }

  openModal = (modal, onClose) => {
    this.setState({modal, modal_onclose: onClose});
  };

  hideModal = () => {
    if (this.state.modal_onclose)
      this.state.modal_onclose();
    this.setState({modal: null, modal_onclose: null});
  }

  confirm = (classes, title, message, options = {}) => {
    // Apply defaults
    options = {
      prompt: false,
      confirmBtnText: "Confirmar",
      cancelBtnText: "Cancelar",
      warning: true,
      ...options
    }
    let prompt_value = "";
    return new Promise((resolve) => {
      this.setState({
        confirm: <SweetAlert
          {...options}
          title={title}
          onConfirm={() => {
            this.setState({confirm: null});
            resolve(prompt_value);
          }}
          onCancel={() => this.setState({confirm: null})}
          showCancel
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm
          }
          cancelBtnCssClass={
            classes.button
          }
        >
          <p>{message}</p>
          {options.prompt && <CustomInput
            formControlProps={{
              fullWidth: true,
              style: {padding: 0, margin: 0}
            }}
            inputProps={{
              type: "text",
              placeholder: options.prompt_placeholder,
              multiline: true,
              rows: 3,
              onChange: (e) => {
                prompt_value = e.target.value
              }
            }}
          />}
        </SweetAlert>
      });
    });
  };
}

if (process.env.NODE_ENV !== 'development') {
  console.warn = () => {
  };
  console.error = () => {
  };
}

ReactDOM.render(
  <React.Fragment>
    <App>
      <Router history={hist}>
        <Switch>
          {indexRoutes.map((prop, key) => {
            return <Route path={prop.path} component={prop.component} key={key}/>;
          })}
        </Switch>
      </Router>
    </App>
    <NotificationContainer/>
  </React.Fragment>,
  document.getElementById("root")
);
